import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx'; // Importa a biblioteca xlsx
import { saveAs } from 'file-saver'; // Importa a função saveAs do file-saver

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  exportToExcel(json: any[], excelFileName: string): void {
    // 1. Cria uma planilha a partir do array JSON
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    // 2. Cria um livro de trabalho (workbook) e adiciona a planilha
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    // 3. Escreve o arquivo Excel em um ArrayBuffer
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 4. Converte o ArrayBuffer para um Blob (tipo de arquivo binário)
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    // Cria um Blob com o tipo MIME correto para Excel
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

    // Usa file-saver para iniciar o download do arquivo
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
